export default {
    word: {
        hello: 'こんにちは',
        voices: '声',
        fans: 'ファン',
        amounts: '数',
        none: 'ない'
    },
    comb: {
        voicesAmounts: '声数',
        fansAmounts: 'ファン数'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/jp.js